import { render, staticRenderFns } from "./side-menu-group.vue?vue&type=template&id=b9d115fe"
import script from "./side-menu-group.ts?vue&type=script&lang=js&external"
export * from "./side-menu-group.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports